import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { putDataPromise } from 'brock-fetch-utils';
import EditorLayout from './EditorLayout';
import { useLabelContext } from '../shared/hooks/labelContext';
import DashboardContext from '../shared/hooks/dashboardContext';
import { getErrorMessageToDisplay } from '../viewDashboards/widgets/utils/wrapperUtils';

export default function Create(props) {
    const { dashboardLabels } = useLabelContext();
    const { menuUtilities, uriConstants } = useContext(DashboardContext);
    const [errorMessage, setErrorMessage] = useState();

    function navigateToCustomDashboard(dashboardConfiguration, dashboardKey) {
        props.history.push({
            pathname: `/Custom/${dashboardKey || 'View'}`,
            state: {
                isCreateMode: true,
                dashboardConfiguration: JSON.stringify(dashboardConfiguration),
            },
        });
    }

    function saveDashboard(configuration) {
        const dashboardKey = uuid();
        const dashboardConfiguration = JSON.stringify(configuration);

        Promise.all([
            putDataPromise(uriConstants.addUserDashboardUri, {
                dashboardKey,
                dashboardConfiguration,
            }),
            menuUtilities.saveUserDashboard(dashboardKey, configuration.title),
        ]).then(
            () => {
                props.reloadPageTo(`/Custom/${dashboardKey}`);
            },
            (error) =>
                setErrorMessage(
                    getErrorMessageToDisplay(
                        error,
                        dashboardLabels.errorSavingLandingPage
                    )
                )
        );
    }

    if (errorMessage) {
        throw Error(errorMessage);
    }

    return (
        <EditorLayout
            dashboardConfiguration={props.dashboardConfiguration}
            errorMessage={errorMessage}
            isCreateMode={true}
            navigateToCustomDashboard={navigateToCustomDashboard}
            saveDashboard={saveDashboard}
            selectedWidgetId={props.selectedWidgetId}
        />
    );
}

Create.propTypes = {
    dashboardConfiguration: PropTypes.instanceOf(Object),
    history: PropTypes.instanceOf(Object).isRequired,
    reloadPageTo: PropTypes.func.isRequired,
    selectedWidgetId: PropTypes.string,
};
